<xemex-side-nav [items]="topItems()" [bottomItems]="bottomItems()" [collapsed]="collapsedMenu()" />
